export const locale = {
  lang: "fr-CA",
  data: {
    PROCESSES: {
      ONGOING_PROCESS: "Processus en cours...",
      DISMISS: "Retirer",
    },
  },
};
